import { render, staticRenderFns } from "./GenericInputDialogFromAction.vue?vue&type=template&id=a073cd72&scoped=true&"
import script from "./GenericInputDialogFromAction.vue?vue&type=script&lang=js&"
export * from "./GenericInputDialogFromAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a073cd72",
  null
  
)

export default component.exports